<template>
  <footer class="app-footer">
    <a href="http://jockey.getlocal.co">Jockey</a> &copy; 2017 GPO
    <span class="float-right">Powered by <a href="http://getlocal.co">GetLocal</a></span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?68a00c6a